import { useState } from "react";

import { Button, Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";

import Edit from "@/assets/svg/edit.tsx";
import Input from "@/common/components/form/Input.tsx";
import { useCalculate } from "@/modules/dwelling/containers/DwellingEstimateContainer/Calculate/useCalculate.tsx";
import {
  DwellingCostDilapidationsResponse,
  OccupationPeriod,
} from "@/modules/dwelling/containers/DwellingEstimateContainer/types.ts";
import { resolveOccupancyDuration } from "@/modules/dwelling/containers/DwellingEstimateContainer/utils";

export const DwellingDuration = ({
  dilapidations,
  occupationPeriod,
}: {
  dilapidations: DwellingCostDilapidationsResponse;
  occupationPeriod: OccupationPeriod;
}) => {
  const [showModalDuration, setShowModalDuration] = useState(false);
  const [occupationPeriodValues, setOccupationPeriodValues] =
    useState<OccupationPeriod>(occupationPeriod);

  const { handleChangeDuration } = useCalculate();
  const form = useForm<any>({
    defaultValues: {
      months: occupationPeriod.months ?? 0,
      years: occupationPeriod.years ?? 0,
    },
  });

  const handleSubmit = (data: OccupationPeriod) => {
    // Make sure we have valid values
    const sanitizedData = {
      years: Number(data.years) || 0,
      months: Number(data.months) || 0,
      days: 0, // Days are typically not editable in the UI
    };

    // Update the context with the new occupation period
    handleChangeDuration(sanitizedData, dilapidations);

    // Update local state
    setOccupationPeriodValues(sanitizedData);

    // Close the modal
    handleClose();
  };

  const handleClose = () => {
    setShowModalDuration(false);
  };

  return (
    <>
      {resolveOccupancyDuration(occupationPeriodValues)}
      <Button
        variant="outline-primary"
        onClick={() => setShowModalDuration(true)}
        className={"ms-2 p-1"}
      >
        <Edit className={"me-1"} /> Éditer
      </Button>
      <Modal
        centered={true}
        show={showModalDuration}
        onHide={() => setShowModalDuration(false)}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <h3>Temps d'occupation</h3>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className={"d-flex flex-column px-5"}>
          <div className={"d-flex align-items-center mb-1"}>
            <Input
              name={"months"}
              type={"number"}
              control={form.control}
              class={"duration"}
            />
            <label className="ms-3">Mois</label>
          </div>
          <div className={"d-flex align-items-center"}>
            <Input
              name={"years"}
              type={"number"}
              control={form.control}
              class={"duration"}
            />
            <label className="ms-3">Années</label>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={handleClose} variant="secondary">
            Annuler
          </Button>
          <Button
            type={"button"}
            onClick={() => form.handleSubmit(handleSubmit)()}
            variant="primary"
          >
            Modifier
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
